const menuItemClassName =
  'm-0 flex w-20 gap-2.5 p-2.5 text-left align-middle text-sm font-medium capitalize leading-[150%] text-[var(--color-text-muted)] hover:bg-[var(--color-surface-muted)]';

const menuDividerClassName = 'm-0 h-0 border-b border-[var(--color-border)] p-0';

const menuDangerItemClassName =
  'm-0 flex w-20 gap-2.5 p-2.5 text-left align-middle text-sm font-medium capitalize leading-[150%] text-[var(--color-text-muted)] hover:bg-[var(--color-danger)] hover:text-[var(--color-fixed-white)]';

export const getMenuItemClassName = (className?: string) => {
  if (className === 'divider') {
    return menuDividerClassName;
  }

  if (className === 'red') {
    return menuDangerItemClassName;
  }

  return [menuItemClassName, className].filter(Boolean).join(' ');
};
